var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"56ce84fcc978dacd74996be0e00380c69ef545ef"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["website@lit-fibre-ltd"]={id:"56ce84fcc978dacd74996be0e00380c69ef545ef"};
      